import { render, staticRenderFns } from "./BODList.vue?vue&type=template&id=27db5c9e&"
import script from "./BODList.vue?vue&type=script&lang=js&"
export * from "./BODList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports